export interface BannerPalette {
  name: string;
  primary: string;
  accent: string;
  background: string;
  foreground: string;
}

export interface BannerTemplate {
  id: string;
  category: string;
  label: string;
  image_url: string;
  palette?: BannerPalette;
}

export const bannerPalettes: BannerTemplate[] = [
  {
    id: "palette-terracota-creme",
    category: "Paleta de cores",
    label: "Terracota & Creme",
    image_url: "",
    palette: {
      name: "Terracota & Creme",
      primary: "#C1785C",
      accent: "#D4A574",
      background: "#FDF6EE",
      foreground: "#3C2215",
    },
  },
  {
    id: "palette-jardim-secreto",
    category: "Paleta de cores",
    label: "Jardim Secreto",
    image_url: "",
    palette: {
      name: "Jardim Secreto",
      primary: "#7C9A7E",
      accent: "#B8A6C4",
      background: "#F7F3EF",
      foreground: "#2D3A2E",
    },
  },
  {
    id: "palette-por-do-sol",
    category: "Paleta de cores",
    label: "Pôr do Sol",
    image_url: "",
    palette: {
      name: "Pôr do Sol",
      primary: "#D4846A",
      accent: "#E8B85C",
      background: "#FFF8F2",
      foreground: "#4A3025",
    },
  },
];

export const bannerTemplates: BannerTemplate[] = [
  ...bannerPalettes,
  {
    id: "tpl-divulgar-negocio",
    category: "Divulgar negócio",
    label: "Divulgar negócio",
    image_url: "/img/readdy/6fb19ec81f73.jpg",
  },
  {
    id: "tpl-oferecer-servicos",
    category: "Oferecer serviços",
    label: "Oferecer serviços",
    image_url: "/img/readdy/bc547036e240.jpg",
  },
  {
    id: "tpl-buscar-vaga",
    category: "Buscar vaga",
    label: "Buscar vaga",
    image_url: "/img/readdy/67267d1e924f.jpg",
  },
  {
    id: "tpl-parcerias",
    category: "Parcerias e networking",
    label: "Parcerias e networking",
    image_url: "/img/readdy/47f57ca5fec9.jpg",
  },
  {
    id: "tpl-evento-feira",
    category: "Evento e feira de negócios",
    label: "Evento e feira de negócios",
    image_url: "/img/readdy/cee8d9c7838d.jpg",
  },
  {
    id: "tpl-comunidade",
    category: "Comunidade Entre Elas",
    label: "Comunidade Entre Elas",
    image_url: "/img/readdy/a2d91fd25518.jpg",
  },
];

export function getBannerImageUrl(template: BannerTemplate): string {
  if (template.palette) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1440" height="400">
      <defs>
        <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${template.palette.primary}"/>
          <stop offset="50%" style="stop-color:${template.palette.accent}"/>
          <stop offset="100%" style="stop-color:${template.palette.background}"/>
        </linearGradient>
      </defs>
      <rect width="1440" height="400" fill="url(#g)"/>
    </svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  }
  return template.image_url;
}